import React from "react";

const Sindh = () => {
  return (
    <>
      <h1>Work in Progress</h1>
    </>
  );
};

export default Sindh;
